<template>
  <div class="test">
    <h1>这是模板</h1>
  </div>
</template>

<script>
import KeyBoardInput from "@/components/KeyBoardInput";
export default {
  name: "test",
  components: {
    KeyBoardInput
  },
  data() {
    return {
      value: "",
      ws: null,
      count: 0,
      t:null
    };
  },
  created() {
    this.connection();
  },
  mounted() {},
  methods: {
    connection() {
      let _this = this;
      _this.ws = new WebSocket("ws://47.104.77.214:9501");
      console.log(_this.ws.readyState)
      _this.ws.onopen = function(e) {
        console.log("连接服务器成功");
        let mes = JSON.stringify({ uid: 125, mid: "果园" });
        _this.ws.send(mes);
      };
      _this.ws.onclose = function(e) {
        console.log("服务器关闭");
        _this.reconnection();
      };
      _this.ws.onerror = function() {
        console.log("连接出错");
        _this.reconnection();
      };
      _this.ws.onmessage = function(e) {
        console.log(e);
        // if (e.data == 1) {
        //   new Audio(
        //     "http://tts.baidu.com/text2audio?cuid=baiduid&lan=zh&ctp=1&pdt=311&tex=美博优品收款:" +
        //       _this.$route.query.audiosrc +
        //       "元"
        //   ).play();
        //   _this.$router.replace({
        //     path: "/home/successbuy1",
        //     query: {
        //       nonext: 1,
        //       isQrcode: 2,
        //       amount: _this.$route.query.audiosrc
        //     }
        //   }); //进行跳转
        // }
      };
    },
    reconnection() {
      console.log("99")
      let _this = this;
      this.count = this.count + 1;
      console.log("reconnection...【" + this.count + "】"); // 1与服务器已经建立连接
      if (this.count >= 1000 || this.ws.readyState == 1) {
        clearTimeout(this.t);
      } else {
        // 2已经关闭了与服务器的连接
        if (this.ws.readyState == 3) {
          this.connection();
        } // 0正尝试与服务器建立连接,2正在关闭与服务器的连接
        this.t = setTimeout(function() {
          _this.reconnection();
        }, 100);
      }
    }
  },
  beforeDestroy() {
    let _this = this;
    _this.ws.onclose = function() {
      clearTimeout(_this.t);
    };
    _this.ws.onclose();
    clearTimeout(this.t);
  }
};
</script>

<style lang="less" scoped>
.test {
  position: relative;
  .myinput {
    height: 1rem;
  }
  .ujd {
    width: 100%;
    padding: 0 0.3rem;
    box-sizing: border-box;
  }
}
</style>